module.exports = __webpack_public_path__ + "img/france-cancer-male.8de645db.png";